import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './shared/footer/footer.component';
import { MaterialModule } from './shared/material/material.module';
import { RutasRoutingModule } from './modules/rutas/rutas-routing.module';
import { InicioRoutingModule } from './modules/inicio/inicio-routing.module';
import { BtnBackComponent } from './shared/components/btn-back/btn-back.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ConfirmDialogComponent } from './shared/components/modals/confirm-dialog/confirm-dialog.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { APP_DATE_FORMATS } from './shared/utils/time-adapter/date-formats';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AuthInterceptor } from './shared/utils/interceptors/auth.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    BtnBackComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    RutasRoutingModule,
    InicioRoutingModule,
    HttpClientModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
